var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.6667 7.00016V6.06683C18.6667 4.76004 18.6667 4.10665 18.4123 3.60752C18.1886 3.16847 17.8317 2.81152 17.3926 2.58781C16.8935 2.3335 16.2401 2.3335 14.9333 2.3335H13.0667C11.7599 2.3335 11.1065 2.3335 10.6074 2.58781C10.1683 2.81152 9.81136 3.16847 9.58765 3.60752C9.33333 4.10665 9.33333 4.76004 9.33333 6.06683V7.00016M3.5 7.00016H24.5M22.1667 7.00016V20.0668C22.1667 22.027 22.1667 23.0071 21.7852 23.7558C21.4496 24.4144 20.9142 24.9498 20.2556 25.2854C19.5069 25.6668 18.5268 25.6668 16.5667 25.6668H11.4333C9.47315 25.6668 8.49306 25.6668 7.74437 25.2854C7.0858 24.9498 6.55037 24.4144 6.21481 23.7558C5.83333 23.0071 5.83333 22.027 5.83333 20.0668V7.00016",
    stroke: "#121215",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/Delete.ba42d9bd657cebb9f02ab103e50c0405.svg";
export { ForwardRef as ReactComponent };